export class AttendeesList {
    selectedAttendee: string;
    role: string;
    email: number;
    isRequired: boolean;
    isAddtional: boolean;
    constructor(data: any) {
        this.selectedAttendee = data?.selectedAttendee;
        this.role = data?.role;
        this.email = data?.email;
        this.isRequired = data?.isRequired;
        this.isAddtional = true;
    }
}